import networkManager from '../NetworkManager/index'
import ApiNames from '../ApiNames/Notification'

class Notification {
  constructor (context) {
    this.context = context
  }

  async getAllNotifications (data) {
    this.context.$store.commit('liveData/set_loading', true)
    const response = await networkManager.getRequest(ApiNames.getAllNotifications, data)
    this.context.$store.commit('liveData/set_loading', false)
    return response.result
  }

  async getTodaysNotifications (data) {
    this.context.$store.commit('liveData/set_loading', true)
    const response = await networkManager.getRequest(ApiNames.getTodaysNotifications, data)
    this.context.$store.commit('liveData/set_loading', false)
    return response.result
  }
}

export default Notification
